import { X, AlertTriangle, CheckCircle, Info } from "lucide-react";
import { Button } from "@/components/Button";

export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirmar acción",
  message = "¿Estás seguro de que deseas continuar?",
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  variant = "warning", // 'warning', 'danger', 'success', 'info'
  loading = false
}) {
  if (!isOpen) return null;

  const variantConfig = {
    warning: {
      icon: AlertTriangle,
      iconColor: "text-yellow-600",
      iconBg: "bg-yellow-100",
      buttonColor: "bg-yellow-600 hover:bg-yellow-700"
    },
    danger: {
      icon: AlertTriangle,
      iconColor: "text-red-600",
      iconBg: "bg-red-100",
      buttonColor: "bg-red-600 hover:bg-red-700"
    },
    success: {
      icon: CheckCircle,
      iconColor: "text-green-600",
      iconBg: "bg-green-100",
      buttonColor: "bg-green-600 hover:bg-green-700"
    },
    info: {
      icon: Info,
      iconColor: "text-blue-600",
      iconBg: "bg-blue-100",
      buttonColor: "bg-blue-600 hover:bg-blue-700"
    }
  };

  const config = variantConfig[variant] || variantConfig.warning;
  const Icon = config.icon;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-in fade-in">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full animate-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="p-6 pb-4">
          <div className="flex items-start gap-4">
            <div className={`flex-shrink-0 w-12 h-12 rounded-full ${config.iconBg} flex items-center justify-center`}>
              <Icon className={`w-6 h-6 ${config.iconColor}`} />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {message}
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
              disabled={loading}
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Actions */}
        <div className="p-6 pt-2 flex gap-3 justify-end border-t border-gray-100">
          <Button
            variant="ghost"
            onClick={onClose}
            disabled={loading}
            className="text-gray-600 hover:text-gray-900"
          >
            {cancelText}
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              if (!loading) onClose();
            }}
            disabled={loading}
            className={`${config.buttonColor} text-white`}
          >
            {loading ? "Procesando..." : confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
}
